import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import classnames from 'classnames';
// eslint-disable-next-line react/display-name
export const ButtonGroup = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { className, bsSize, children, vertical, ...rest } = props;
    const btnGroupClass = vertical ? 'btn-group-vertical' : 'btn-group';
    const bsClass = classnames(btnGroupClass, {
        [`btn-group-${bsSize}`]: !!bsSize
    }, className);
    return /*#__PURE__*/ _jsx("div", {
        ...rest,
        ref: ref,
        className: bsClass,
        role: "group",
        "aria-label": "Button group",
        children: children
    });
});
